import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import ShellHeader from './ShellHeader';
import { withAuth } from 'services/AuthProvider';
import { Store } from 'store/storeTypes';
import {
  isReadOnlyRoleSelector,
  profilePictureUrlSelector,
  screenWidthSelector,
  userEmailSelector,
} from 'reducers/appUserReducer';
import { systemGroupSelector } from 'reducers/ui/systemGroupUiReducer';
import { activeSystemsBySystemGroupSelector } from 'reducers/reports/filterDataReducer';
import { importedTenantIdSelector, tenantNameSelector } from 'reducers/userSettingsReducer';
import {
  apolloLastUpdateSelector,
  dtfLastUpdateSelector,
  dtgLastUpdateSelector,
} from 'reducers/apiStateReducer';
import { activeReportSelector } from 'reducers/reports/filterStateReducer';
import { overviewTimeOfLastMainResponseSelector } from 'reducers/overviewReducer';
import { bindActionCreators, Dispatch } from 'redux';
import { setSystemGroup } from 'actions/userUiActions';

const mapStateToProps = (state: Store) => {
  return {
    profilePictureUrl: profilePictureUrlSelector(state),
    activeSystems: activeSystemsBySystemGroupSelector(state),
    lastUpdateDTG: dtgLastUpdateSelector(state),
    lastUpdateDTF: dtfLastUpdateSelector(state),
    lastUpdateApollo: apolloLastUpdateSelector(state),
    selectedSystemGroup: systemGroupSelector(state),
    tenantName: tenantNameSelector(state),
    importedTenantId: importedTenantIdSelector(state),
    screenWidth: screenWidthSelector(state),
    activeReport: activeReportSelector(state),
    userEmail: userEmailSelector(state),
    isReadOnlyRole: isReadOnlyRoleSelector(state),
    lastResponseUpdateTime: overviewTimeOfLastMainResponseSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ setSystemGroup }, dispatch);

export type ShellHeaderProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<Record<string, string>>;

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(withRouter(ShellHeader)));
